module.exports = __webpack_public_path__ + "static/media/angalong.214703ef.jpg";